var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.linkText || "Default link text"))])]},{"open":_vm.open})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }